import { Check, Info, TriangleAlert, X } from 'lucide-react';
import { toast } from 'sonner';

type ToastType = 'success' | 'error' | 'info' | 'warning';

export function useToast() {
  function show(type: ToastType, title: string, message?: string) {
    const icons = {
      success: <Check className="text-white" />,
      error: <X className="text-white" />,
      warning: <TriangleAlert className="text-white" />,
      info: <Info className="text-white" />,
    };

    toast(title, {
      description: message,
      icon: icons[type],
      position: 'bottom-center',
      duration: 4000,
    });
  }

  function success(message: string, title = 'Sucesso') {
    show('success', title, message);
  }

  function error(message: string, title = 'Erro') {
    show('error', title, message);
  }

  function info(message: string, title = 'Informação') {
    show('info', title, message);
  }

  function warning(message: string, title = 'Atenção') {
    show('warning', title, message);
  }

  return {
    show,
    success,
    error,
    info,
    warning,
  };
}
